import { INITIALIZE_CUSTOMER_LANGUAGE } from './types';
export function initializeCustomerLanguage(payload) {
    return {
        type: INITIALIZE_CUSTOMER_LANGUAGE,
        payload: payload
    };
}
 
